<template>
  <div class="timepicker tmpckr flex-1">
    <div class="tmpckr_column">
      <div
        class="clr-gres position-relative text-medium f-center"
        style="padding: 1rem; z-index: 4"
      >
        {{ $t('common.hours') }}
      </div>
      <GwBtns
        style="
          overflow-y: auto;
          --gwbtns-direction: column;
          --gwbtn-clr: var(--clr-white-0);
          --gwbtn-clr-back: transparent;
          --gwbtn-clr-active-white: var(--clr-primary);
          --gwbtn-clr-hover-white: var(--clr-black-1-3);
          --gwbtn-height: 2rem;
          --gwbtn-radius: 99px;
          --gwbtn-flex: auto;
          padding: 0 2px 0 0;
        "
        :value="l_hours"
        :options="
          Array(24)
            .fill(1)
            .map((x, idx) => (idx > 9 ? idx.toString() : '0' + idx))
        "
        @click="(_e, val) => onChange(val, 'hours')"
      >
        <template #default="{ item }">
          <div :ref="item === l_hours ? 'active_hours' : null">
            {{ item }}
          </div>
        </template>
      </GwBtns>
    </div>
    <div class="tmpckr_column">
      <div
        class="clr-gres position-relative text-medium f-center"
        style="padding: 1rem; z-index: 4"
      >
        {{ $t('common.minutes') }}
      </div>
      <GwBtns
        style="
          overflow-y: auto;
          --gwbtns-direction: column;
          --gwbtn-clr: var(--clr-white-0);
          --gwbtn-clr-back: transparent;
          --gwbtn-clr-active-white: var(--clr-primary);
          --gwbtn-clr-hover-white: var(--clr-black-1-3);
          --gwbtn-height: 2rem;
          --gwbtn-radius: 99px;
          --gwbtn-flex: auto;
          padding: 0 2px 0 0;
        "
        :value="l_minutes"
        :options="
          Array(60)
            .fill(1)
            .map((x, idx) => (idx > 9 ? idx.toString() : '0' + idx))
        "
        @click="(_e, val) => onChange(val, 'minutes')"
      >
        <template #default="{ item }">
          <div :ref="item === l_minutes ? 'active_minutes' : null">
            {{ item }}
          </div>
        </template>
      </GwBtns>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import GwBtns from '@/components/lib/GwBtns'

export default {
  name: 'TimePicker',
  components: {
    GwBtns,
  },
  props: { value: String },
  emits: ['change'],
  data() {
    return {
      l_time: this.value,
    }
  },
  mounted() {
    nextTick(() => {
      if (this.$refs.active_hours) this.$refs.active_hours.scrollIntoView()
      if (this.$refs.active_minutes) this.$refs.active_minutes.scrollIntoView()
    })
  },
  methods: {
    onChange(val, type) {
      if (type === 'hours') {
        this.l_time = `${val}:${this.l_minutes}`
      } else {
        this.l_time = `${this.l_hours}:${val}`
      }
      this.$emit('change', this.l_time)
    },
  },
  computed: {
    l_minutes() {
      return this.l_time.split(':')[1]
    },
    l_hours() {
      return this.l_time.split(':')[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.tmpckr {
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
  --tmpckr-height: auto;
  --tmpckr-min-width: 14rem;
  min-width: var(--tmpckr-min-width);
  border: solid 1px var(--clr-black-1-1);
  border-radius: 4px;
  overflow: hidden;
  background: #212121;
  gap: 0.5rem;
  padding: 0 1rem 1rem 1rem;
  max-height: 26.75rem;
  &_column {
    height: var(--tmpckr-height);
    display: flex;
    // padding: 0 1rem 0.5rem 1rem;
    flex-direction: column;
    overflow: hidden;
    border-radius: 4px;
    width: 100%;
  }
}
</style>
